import { useCallback, useEffect, useState } from 'react';

export type Theme = 'dark' | 'light';
const KEY = 'glyph-theme';

export function readTheme(): Theme {
  try {
    const t = localStorage.getItem(KEY);
    if (t === 'light' || t === 'dark') return t;
  } catch {
    /* no storage */
  }
  return 'light';
}

export function applyTheme(t: Theme) {
  if (typeof document === 'undefined') return;
  document.documentElement.dataset.theme = t;
  document.documentElement.style.colorScheme = t;
}

/** Theme persisted to localStorage and applied as `data-theme` on <html>. Light is the default. */
export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(() => readTheme());
  useEffect(() => applyTheme(theme), [theme]);
  const setTheme = useCallback((t: Theme) => {
    setThemeState(t);
    try {
      localStorage.setItem(KEY, t);
    } catch {
      /* ignore */
    }
  }, []);
  const toggle = useCallback(() => setTheme(theme === 'light' ? 'dark' : 'light'), [theme, setTheme]);
  return { theme, setTheme, toggle, /** label for the toggle button: the theme you would switch TO */ nextLabel: theme === 'light' ? 'DARK' : 'LIGHT' };
}
